$(document).ready(function () {
  let submitButton = $('#subscribe_submit_button');
  let subscribeModal = $('#subscribeModal');
  let warningModal = $('#NonInformedProfileWarningModal');
  let walletBalance = $('#walletBalance').html();
  let humanWalletBalance = $('#humanWalletBalance').html();
  let errorWalletBalance = $('#errorWalletBalance').html();

  if (submitButton.length == 0) {
    return;
  }

  $(".subscribe_modal_checkbox").on('change', function(){
    subscribeCheckBoxAllChecked()
  })

  $(".warning_modal_checkbox").on('change', function(){
    warningSubscribeCheckBoxAllChecked()
  })

  submitButton.click(triggerSubscriptionConfirmModal);
  $(document).on("keydown", "#newSubscriptionForm", function(event) {
    if (event.keyCode == 13) {
      event.preventDefault();
      triggerSubscriptionConfirmModal();
      return;
    }
  });

  warningModal.on("shown.bs.modal", function() {
    warningSubscribeCheckBoxAllChecked()
  });

  subscribeModal.on("shown.bs.modal", function() {
    subscribeCheckBoxAllChecked()
  });

  function warningSubscribeCheckBoxAllChecked() {
    let confirmButton = $("#warning_subscribe_confirm_button");

    if ($(".warning_modal_checkbox:checked").length == $(".warning_modal_checkbox").length) {
      confirmButton.attr("disabled", false)
    } else {
      confirmButton.attr("disabled", true)
    }
  }

  function subscribeCheckBoxAllChecked() {
    let confirmButton = $("#subscribe_confirm_button");

    if ($(".subscribe_modal_checkbox:checked").length == $(".subscribe_modal_checkbox").length) {
      confirmButton.attr("disabled", false)
    } else {
      confirmButton.attr("disabled", true)
    }
  }

  function triggerSubscriptionConfirmModal() {
    let subscriptionAmountField = $("#subscription_number_of_shares_field");
    let subscribeModal = $('#NonInformedProfileWarningModal');

    let amount = parseInt(subscriptionAmountField.val());
    let projectShareValue = subscriptionAmountField.data("projectShareValue");

    if (!(amount % projectShareValue === 0)) {
      document.getElementById("fields_errors").innerHTML = `Le montant entré n'est pas un multipe de ${projectShareValue}`;
      return false;
    }

    if (walletBalance - amount < 0) {
      error_message = errorWalletBalance.replace("balance__placeholder", humanWalletBalance)
      toastr["error"](error_message);
      return false;
    }

    if (subscriptionAmountField.data("userMayHaveWarning") === true) {
      Rails.ajax({
        type: "GET",
        url: subscriptionAmountField.data("url"),
        data: '&[amount]=' + amount,
        dataType: "json",
        success: function(response) {
          let warning_modal_required = response["warning_modal_required"]

          if (warning_modal_required) {
            warningModal.modal('show');
          } else {
            $('#subscribeModal').modal('show');
          }
        },
        error: function(response) {
          document.getElementById("fields_errors").innerHTML = "Une erreur s'est produite, veuillez réessayer.";
        }
      });
    } else {
      $('#subscribeModal').modal('show');
    }
  };
});
